// 19.1.3.19 Object.setPrototypeOf(O, proto)
var $export = require('./_export');
$export($export.S, 'Object', { setPrototypeOf: require('./_set-proto').set });



//////////////////
// WEBPACK FOOTER
// ./~/@babel/runtime-corejs2/~/core-js/library/modules/es6.object.set-prototype-of.js
// module id = 1480
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16